require('./angular-resource');
module.exports = 'ngResource';



//////////////////
// WEBPACK FOOTER
// ../~/angular-resource/index.js
// module id = 7
// module chunks = 0